import React from "react";
import { Helmet } from "react-helmet-async";

export default function Privacy() {
    return (
        <>
            <Helmet><title>Privacy Policy — OpenCSV</title></Helmet>
            <section className="border-b border-black/10">
                <div className="mx-auto max-w-3xl px-4 md:px-8 py-20">
                    <div className="ui-heading text-xs uppercase tracking-widest text-ink-muted mb-4">/ legal</div>
                    <h1 className="font-display font-black tracking-tighter text-4xl md:text-5xl">Privacy Policy</h1>
                    <p className="mt-2 text-xs text-ink-muted">Last updated: {new Date().toLocaleDateString()}</p>
                    <div className="mt-8 space-y-6 text-sm text-ink-soft leading-relaxed">
                        <section>
                            <h2 className="ui-heading font-bold text-ink text-lg">What we collect</h2>
                            <p>We collect the bare minimum: your email, name, an encrypted password hash (or a Google profile if you sign in with Google), and basic usage logs to keep the service stable.</p>
                        </section>
                        <section>
                            <h2 className="ui-heading font-bold text-ink text-lg">Your CSV files</h2>
                            <p>CSV files are loaded and edited entirely in your browser. If you choose to "Save to cloud," the file is encrypted in transit (HTTPS) and stored only against your account. We never read, mine, or share your file contents.</p>
                        </section>
                        <section>
                            <h2 className="ui-heading font-bold text-ink text-lg">Payments</h2>
                            <p>Payments are processed by Stripe. We never see or store your card number. Stripe's privacy policy applies to payment data.</p>
                        </section>
                        <section>
                            <h2 className="ui-heading font-bold text-ink text-lg">Cookies</h2>
                            <p>We use a single httpOnly authentication cookie to keep you signed in. No tracking pixels, no ad networks, no third-party analytics that follow you around the web.</p>
                        </section>
                        <section>
                            <h2 className="ui-heading font-bold text-ink text-lg">Your rights</h2>
                            <p>You can export, edit, or delete your account and all associated data at any time from your account page. Email us at flyingfitz@gmail.com for help.</p>
                        </section>
                        <section>
                            <h2 className="ui-heading font-bold text-ink text-lg">Children</h2>
                            <p>OpenCSV is not directed at children under 13. If you believe a child has signed up, contact us and we'll delete the account.</p>
                        </section>
                    </div>
                </div>
            </section>
        </>
    );
}
